import { z } from "zod";

/**
 * Incident mail or the log. WhatsApp is not a value here: it is added beside
 * this choice, and production refuses it as the only channel (ADR-098, ADR-103).
 */
export const incidentMailChannelSchema = z.enum(["CONSOLE", "EMAIL"]);

export type IncidentMailChannel = z.infer<typeof incidentMailChannelSchema>;

/** Password-reset and invite mail. Independent of incident mail (ADR-086). */
export const transactionalMailChannelSchema = z.enum(["CONSOLE", "EMAIL"]);

export type TransactionalMailChannel = z.infer<typeof transactionalMailChannelSchema>;

export const updatePlatformSettingsRequestSchema = z
  .object({
    incidentChannel: incidentMailChannelSchema,
    whatsAppEnabled: z.boolean(),
    transactionalEmailChannel: transactionalMailChannelSchema,
  })
  .strict();

export type UpdatePlatformSettingsRequest = z.infer<typeof updatePlatformSettingsRequestSchema>;

/**
 * What the settings screen shows.
 *
 * `*Available` says whether the environment holds the credentials a real send
 * needs. The reasons are for a client that has no translations of its own;
 * the admin UI uses its own copy. Neither field ever carries a secret.
 */
export const platformSettingsSchema = updatePlatformSettingsRequestSchema.extend({
  emailAvailable: z.boolean(),
  whatsAppAvailable: z.boolean(),
  emailUnavailableReason: z.string().nullable(),
  whatsAppUnavailableReason: z.string().nullable(),
});

export type PlatformSettings = z.infer<typeof platformSettingsSchema>;
